import {GetStoreServicesOrdersApiResponse} from "../../../../../react-query-hooks/store/services/get-orders/types";

/**
 * `order` carries the whole selected orders-list item: the v2 order-detail
 * endpoint returns only the work deliveries, so the drawer reads the
 * order-level fields (amount, currency, dates, coach display name) from here.
 */
export type SetSelectedCustomerStoreServiceOrderInfoPayload = {
  productService: GetStoreServicesOrdersApiResponse["orders"][0]["productService"];
  hasBeenReviewed: boolean;
  order: GetStoreServicesOrdersApiResponse["orders"][0];
};

type UpdateStatusId = {
  type: "update-status-id";
  payload: number;
};
type UpdateCurrentPage = {
  type: "update-current-page";
  payload: number;
};
type UpdatePerPage = {
  type: "update-per-page";
  payload: number;
};
type SetSelectedCustomerStoreServiceOrderInfo = {
  type: "set-selected-store-service-order-info";
  payload: SetSelectedCustomerStoreServiceOrderInfoPayload | null;
};
type SetActiveStoreServiceOrderDrawer = {
  type: "set-active-store-service-order-drawer";
  payload:
    | "order-info"
    | "approve-delivery"
    | "request-review"
    | "open-dispute"
    | "leave-a-review"
    | "cancel-order"
    | null;
};

export type GetCustomerStoreServicesOrdersReducerActions =
  | UpdateStatusId
  | UpdateCurrentPage
  | UpdatePerPage
  | SetActiveStoreServiceOrderDrawer
  | SetSelectedCustomerStoreServiceOrderInfo;

export type GetCustomerStoreServicesOrdersReducerState = {
  currentPage: number;
  per_page: number;
  statusId: number;
  selectedStoreServiceOrderInfo: SetSelectedCustomerStoreServiceOrderInfoPayload | null;
  activeStoreServiceOrderDrawer:
    | "order-info"
    | "approve-delivery"
    | "request-review"
    | "open-dispute"
    | "leave-a-review"
    | "cancel-order"
    | null;
};

export const initialGetCustomerStoreServicesOrdersReducerState: GetCustomerStoreServicesOrdersReducerState =
  {
    currentPage: 1,
    per_page: 5,
    statusId: -1,
    selectedStoreServiceOrderInfo: null,
    activeStoreServiceOrderDrawer: null,
  };

export const getCustomerStoreServicesOrdersFormReducer = (
  state: GetCustomerStoreServicesOrdersReducerState = initialGetCustomerStoreServicesOrdersReducerState,
  action: GetCustomerStoreServicesOrdersReducerActions
) => {
  if (action.type === "update-status-id") {
    return {...state, statusId: action.payload, currentPage: 1};
  }
  if (action.type === "update-current-page") {
    return {...state, currentPage: action.payload};
  }
  if (action.type === "update-per-page") {
    return {...state, per_page: action.payload};
  }
  if (action.type === "set-selected-store-service-order-info") {
    return {...state, selectedStoreServiceOrderInfo: action.payload};
  }
  if (action.type === "set-active-store-service-order-drawer") {
    return {...state, activeStoreServiceOrderDrawer: action.payload};
  }
  //   if (action.type === "reset-state") {
  //     return {...initialCreateProductFormState};
  //   }

  return state;
};
